import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import JQuery from 'jquery'
window.$ = JQuery
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/scss/main.scss'
import Vuetify from "vuetify";
Vue.use(Vuetify);
import VuetifySnackbarQueue from 'vuetify-snackbar-queue'
Vue.use(VuetifySnackbarQueue)
import "vuetify/dist/vuetify.min.css";
import { toCurency, formatPrice, formatInt, formatDate } from "./filters";
import * as methods from './helpers/methods'
Vue.prototype.$methods = methods;
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate);
//setting axios data
import axios from './helpers/axios'

//'content-type': 'application/json',
//Vue.prototype.$router = router;

import VueMeta from 'vue-meta'
Vue.use(VueMeta);


import VueGoogleApi from 'vue-google-api'
Vue.prototype.$GA4_PROPERTY_ID = 320041125;

const config = {
  apiKey: 'AIzaSyCmSVEjqg2Q-QFCykOjRsHpAznY-i0Klik',
  clientId: '872471067493-fn7ghqup7gptebctsdj5hs48k1agtp3u.apps.googleusercontent.com',
  scope: 'https://www.googleapis.com/auth/analytics https://www.googleapis.com/auth/analytics.readonly',
  discoveryDocs: [  ]
}
Vue.use(VueGoogleApi, config);

import VuejsDialog from 'vuejs-dialog';
import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
Vue.use(VuejsDialog, {
  html: true,
  loader: true,
  okText: 'Igen',
  cancelText: 'Mégsem',
  animation: 'bounce'
});

import VueSocialSharing from 'vue-social-sharing'
Vue.use(VueSocialSharing);

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
